import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BranchType } from "types/branch";

interface BranchState {
  currentBranch: BranchType | null;
  branches: BranchType[];
  loading: boolean;
  error: string | null;
}

const initialState: BranchState = {
  currentBranch: {
    id: 0,
    name: "",
    address: "",
  },
  branches: [],
  loading: false,
  error: null,
};

const branchesSlice = createSlice({
  name: "branches",
  initialState,
  reducers: {
    setBranchInfo: (state, action: PayloadAction<BranchType>) => {
      state.currentBranch = action.payload;
    },
    setBranches: (state, action: PayloadAction<BranchType[]>) => {
      state.branches = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

export const { setBranchInfo, setBranches, setLoading, setError } =
  branchesSlice.actions;
export default branchesSlice.reducer;
